import '../vendor';

import './map/map-sl';


// WEBPACK FOOTER //
// ./src/js/pages/map.js